/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Wizard_Projects_HintInputs */



/**
* | output |
* | --- |
* | "Link it into projects so the assistant can use it there. You can change this later." |
*
* @param {My_Integrations_Wizard_Projects_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_wizard_projects_hint = /** @type {((inputs?: My_Integrations_Wizard_Projects_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Wizard_Projects_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfen Sie sie mit Projekten, damit der Assistent sie dort nutzen kann. Sie können dies später ändern.")
	return /** @type {LocalizedString} */ ("Link it into projects so the assistant can use it there. You can change this later.")
});